<Section class="error_sec"> 
    <div class="container">
        <div class="error_content">            
            <h1>4<img src="../../../../assets/images/404.gif" alt="img" />4</h1>
            <h3>WE ARE SORRY PAGE NOT FOUND!</h3>
            <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
        </div>
    </div>
</Section>
